import React, { forwardRef } from "react";
import '../../css/components/controls/HrnbTextArea.css'

const HrnbTextArea = forwardRef(function HrnbTextArea({
                                         label,
                                         className = "",
                                         value,
                                         onChange,
                                         placeholder = "",
                                         error = "",
                                         hint = "",
                                         disabled = false,
                                         rows = 4,
                                         ...props
                                     }, ref) {
    return (
        <div className={`hrnb-textarea-wrap ${className} ${error ? "hrnb-textarea--error" : ""} ${disabled ? "hrnb-textarea--disabled" : ""}`}>
            {label && <label className="hrnb-textarea__label">{label}</label>}
            <textarea
                ref={ref}
                className="hrnb-textarea"
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                disabled={disabled}
                rows={rows}
                {...props}
            />
            {error
                ? <div className="hrnb-textarea__error">{error}</div>
                : hint && <div className="hrnb-textarea__hint">{hint}</div>
            }
        </div>
    );
});

export default HrnbTextArea;
